export const wordsCount = (str="") => {
    if(!str) str = "";
    let s = str.match(/[^\s]+/g);
    return s? s.length : 0;
};